import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Restaura o scroll para o topo a cada troca de rota.
 * Sem isso, navegar entre páginas mantém a posição de scroll anterior.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
